import React, { useEffect, useState } from "react";
import "./style.scss";

const calcAspectWidth = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    return width < height * (16 / 9) ? height * (16 / 9) : width;
};

const VideoPlayer = ({ type, src }) => {
    const { origin } = window.location;
    const [calcWidth, setCalcWidth] = useState(calcAspectWidth);
    
    useEffect(() => {
        const handleResize = () => setCalcWidth(calcAspectWidth());
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className="video-js__wrapper">
            {type === "youtube" ? (
                <iframe
                    width={calcWidth || 0}
                    height={calcWidth ? (calcWidth / 16) * 9 : 0}
                    className="video-js__video video-js__video--is-active"
                    src={`https://www.youtube.com/embed/${src}?autoplay=1&mute=1&enablejsapi=1&origin=${origin}`}
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    referrerPolicy="strict-origin-when-cross-origin"
                ></iframe>
            ) : type === "mp4" ? (
                <video
                    className="video-js__video video-js__video--is-active"
                    src={src}
                    width={calcWidth || 0}
                    height={calcWidth ? (calcWidth / 16) * 9 : 0}
                    autoPlay
                    muted
                    controls
                ></video>
            ) : (
                <p>Unsupported video type</p>
            )}
        </div>
    );
};

export default VideoPlayer;
